import { Box, Grid, Typography, Alert } from "@mui/material";
import LoginForm from "./LoginForm";
import VerificationForm from "./VerificationForm";
import { grey } from "@mui/material/colors";
import { useState } from "react";

export function DashedBreakline({ text }: { text: string }) {
  return (
    <Box sx={{ my: 2 }}>
      <Typography sx={{
        fontSize: 13,
        color: grey[700],
        textAlign: 'center',
        position: 'relative',
        '&:before': { content: '" "', width: '100px', height: '1px', position: 'absolute', top: '10px', left: 0, bgcolor: '#f1f1f1' },
        '&:after': { content: '" "', width: '100px', height: '1px', position: 'absolute', top: '10px', right: 0, bgcolor: '#f1f1f1' }
      }}>{text}</Typography>
    </Box>
  )
}

export default function Login() {
  const [verification, setVerification] = useState<string | null>(null)
  const [uncompleted, setUncompleted] = useState<boolean>(false)

  const loginFormContext = {
    verification,
    setVerification,
    uncompleted,
    setUncompleted
  }

  return (
    <Box sx={{ bgcolor: "#F8F8F8", height: "100vh" }}>
      <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ height: "inherit" }}>
        <Grid item md={3} xs={12} sx={{ p: 2 }}>
          <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
            <img src="/assets/icon.png" width={50} height={50} />
          </Box>
          {verification !== null || uncompleted ? (
            <Box sx={{ mb: 2, p: 5, borderRadius: 2, bgcolor: "white" }}>
              {uncompleted && (<Alert severity="error" sx={{ mb: 4, fontSize: 14 }}>Your account verification status is incomplete. Please complete the verification process to access this feature.</Alert>)}
              <Typography fontWeight={600} sx={{ mb: 1, color: grey[900] }}>Verification</Typography>
              <Typography fontSize={14}>Enter the 7-digit code sent to the email {verification}.</Typography>
              <Box sx={{ mt: 3 }}>
                <VerificationForm {...loginFormContext} />
              </Box>
            </Box>
          ) : (
            <Box sx={{ mb: 2, p: 5, borderRadius: 2, bgcolor: "white" }}>
              <Typography fontWeight={600} sx={{ color: grey[900] }}>Login</Typography>
              <Box sx={{ mt: 3 }}>
                <LoginForm {...loginFormContext} />
              </Box>
            </Box>
          )}

          <Typography fontSize={14} color="#9b9b9b">© 2013 VNETWORK JSC. All Rights Reserved</Typography>
        </Grid>
      </Grid>
    </Box>
  )
}